import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AuthUser from "../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../Spinner";

import Swal from "sweetalert2";

const ContaBancariaModal = ({ colaborador_id, onSubmitSuccess }) => {
  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [mostrarFormNovo, setMostrar] = useState(false);
  const [colaborador, setColaborador] = useState([]);
  const [registoSelecionado, setRegistoSelecionado] = useState(0);

  const [conta, setConta] = useState("");
  const [banco_id, setBancoID] = useState(-1);
  const [IBAN, setIBAN] = useState("");
  const [NIB, setNIB] = useState("");
  const [tipo, setTipo] = useState(2);

  const [bancos, setBancos] = useState([]);

  const toggleLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        getBancos();
        getUtilizador(colaborador_id);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [colaborador_id]);

  const getUtilizador = async (colaborador_id) => {
    try {
      setLoading(true); // Set loading to true when the request starts

      if (colaborador_id != 0 && colaborador_id != null) {
        const res = await http.get(
          "/utilizador/" + (colaborador_id ? colaborador_id : 0)
        );

        setColaborador(res.data.utilizador);

        onSubmitSuccess(res.data.utilizador);
      }

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const getBancos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/bancos/'+getMissao()?.id);

      setBancos(res?.data?.bancos);

      setLoading(false);

    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };


  const mostrar = () => {
    setMostrar(!mostrarFormNovo);
  };

  const chamarModalEliminar = (idSelecionado) => {
    setRegistoSelecionado(idSelecionado);

    // eslint-disable-next-line no-restricted-globals
    if (confirm("Tem a certeza que pretende eliminar este registo?")) {
      setLoading(true);
      handleEliminar(idSelecionado);
    }
  };

  const handleEliminar = async (idSelecionado) => {
    try {
      const formData = new FormData();
      formData.append("id", idSelecionado);

      const response = await http.post("/conta/eliminar", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      getUtilizador(colaborador_id);

      // Atualize a lista de acessos após ativar/desativar
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao eliminar o estado do usuário. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  // REGISTO NOVO

  const submitFormNovo = async () => {
    if (verificarPermissao("UTILIZADORES", "adicionar")) {
      try {
        toggleLoading(true);

        if (banco_id == -1) {
         
          setLoading(false);      

          Swal.fire({
            title: "BANCO NÃO DEFINIDO.",
            text: "Deve definir um banco, se possivel volte a definir o que ja esta definido.",
            type: "error",
            showCancelButton: !0,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Certo, entendi!",
            confirmButtonClass: "btn btn-primary",
            cancelButtonClass: "btn btn-danger ml-1",
            buttonsStyling: !1,
          });

          return;
        }

        await registar();

      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Show a error toast
          toast.error("Utilizador não autenticado.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        } else {
          // Show a error toast
          toast.error(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
            {
              position: "top-right",
              autoClose: 3000, // Close the toast after 3 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            }
          );
        }
      } finally {
        toggleLoading(false);
      }
    } else {
      console.log("Clicou em submeter");

      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const registar = async () => {
    if (verificarPermissao("UTILIZADORES", "adicionar")) {
      try {
        const formData = new FormData();
        formData.append("user_id", colaborador_id);
        formData.append("conta", conta);
        formData.append("banco_id", banco_id);
        formData.append("IBAN", IBAN);
        formData.append("NIB", NIB);
        formData.append("tipo", tipo);

        const response = await http.post("/conta/register", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.message == "Registo feito com sucesso") {
          
          setConta("");
          setIBAN("");
          setNIB("");

          mostrar();

          getUtilizador(colaborador_id);
        }
      } catch (error) {
        console.error(error);

        toast.error(
          "Ocorreu um erro ao carregar o utilizador. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          }
        );
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  // ATUALIZAR INFORMACAO

  const submitUpdateForm = async (id, updatedData) => {
    if (verificarPermissao("UTILIZADORES", "atualizar")) {
      try {
        toggleLoading(true);
        await updateInfo(id, updatedData);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Utilizador não autenticado.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        } else {
          toast.error(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            }
          );
        }
      } finally {
        toggleLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      });
    }
  };

  const updateInfo = async (id, updatedData) => {
    if (verificarPermissao("UTILIZADORES", "atualizar")) {
      try {
        const formData = new FormData();
        formData.append("id", id);
        formData.append("conta", updatedData.conta);
        formData.append("banco_id", updatedData.banco_id);
        formData.append("IBAN", updatedData.IBAN);
        formData.append("NIB", updatedData.NIB);
        formData.append("tipo", tipo);

        const response = await http.post(`/conta/update`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.message == "Registo atualizado com sucesso") {
          // Atualizar o estado local com os dados atualizados
          setColaborador((prevState) => ({
            ...prevState,
            contas: prevState.contas.map((item) =>
              item.id == id ? { ...item, ...updatedData } : item
            ),
          }));

          getUtilizador(colaborador_id);
        }
      } catch (error) {
        console.error(error);
        toast.error(
          "Ocorreu um erro ao atualizar a informação pessoal. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          }
        );
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      });
    }
  };

  const renderOptionBancos = (bancos) => {
    return bancos?.map((banco) => (
      <React.Fragment key={banco.id}>
        <option value={banco.id}>{banco.sigla}</option>
      </React.Fragment>
    ));
  };

  return (
    <>
      {/* Personal Info Modal */}
      <div
        id="conta_bancaria_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Contas Bancaria [ {colaborador?.name} ]</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              {colaborador?.contas?.map((item, index) => (
                <>
                  <div className="card">
                    <div className="card-body">
                      <h3 className="card-title">
                        {t("Conta Bancaria # ")} {index + 1}
                        <span
                          className="delete-icon"
                          onClick={() => chamarModalEliminar(item?.id)}
                        >
                          <i className="fa-regular fa-trash-can" />
                        </span>
                      </h3>

                      <form>
                        <div className="row">


                        <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <select
                                className="form-control select"
                                value={item.banco_id}
                                onChange={(e) =>
                                  setColaborador((prevState) => {
                                    const updatedInfo = [
                                      ...prevState.contas,
                                    ];
                                    updatedInfo[index].banco_id =
                                      e.target.value;
                                    return {
                                      ...prevState,
                                      contas: updatedInfo,
                                    };
                                  })
                                }
                              >
                                <option value={-1}> - </option>
                                 {renderOptionBancos(bancos)}
                              </select>
                              <label className="focus-label">
                                {t("Banco")}{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <input
                                type="text"
                                className="form-control"
                                value={item.conta?item.conta:''}
                                onChange={(e) =>
                                  setColaborador((prevState) => {
                                    const updatedInfo = [
                                      ...prevState.contas,
                                    ];
                                    updatedInfo[index].conta =
                                      e.target.value;
                                    return {
                                      ...prevState,
                                      contas: updatedInfo,
                                    };
                                  })
                                }
                              />

                              <label className="focus-label">
                                {t("Nº de Conta")}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <input
                                className="form-control"
                                type="text"
                                value={item.IBAN?item.IBAN:''}
                                onChange={(e) =>
                                  setColaborador((prevState) => {
                                    const updatedInfo = [
                                      ...prevState.contas,
                                    ];
                                    updatedInfo[index].IBAN =
                                      e.target.value;
                                    return {
                                      ...prevState,
                                      contas: updatedInfo,
                                    };
                                  })
                                }
                              />

                              <label className="focus-label">
                                {t("IBAN")}
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <input
                                className="form-control"
                                type="text"
                                value={item.NIB?item.NIB:''}
                                onChange={(e) =>
                                  setColaborador((prevState) => {
                                    const updatedInfo = [
                                      ...prevState.contas,
                                    ];
                                    updatedInfo[index].NIB =
                                      e.target.value;
                                    return {
                                      ...prevState,
                                      contas: updatedInfo,
                                    };
                                  })
                                }
                              />
                              <label className="focus-label">
                                {t("NIB")}
                              </label>
                            </div>
                          </div>
                        

                       

                          <div className="submit-section">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => submitUpdateForm(item.id, item)}
                            >
                              {t("Atualizar Informação")}
                            </button>
                          </div>

                          <hr className="mt-4"></hr>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              ))}

              <div className="add-more ml-2 mt-3 ">
                <span onClick={mostrar} className="mt-4 btn btn-primary">
                  <i className="fa-solid fa-plus-circle" />
                  {t("Add More")}
                </span>
              </div>

              <div className="card">
                <div className="card-body">
                  {mostrarFormNovo ? (
                    <>
                      {" "}
                      <form>
                        <div className="row mt-4">

                        <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <select
                                className="form-control select"
                                onChange={(e) => setBancoID(e.target.value)}
                              >
                                <option value={-1}> - </option>
                                 {renderOptionBancos(bancos)}
                              </select>

                              <label className="focus-label">
                                {t("Banco")}{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <input
                                type="number"
                                className="form-control"
                                onChange={(e) => setConta(e.target.value)}
                              />
                              <label className="focus-label">
                                {t("Nº De Conta")}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <div>
                                <input
                                  className="form-control"
                                  type="text"
                                  onChange={(e) =>
                                    setIBAN(e.target.value)
                                  }
                                />
                                <label className="focus-label">
                                  {t("IBAN")}
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="input-block mb-3 mb-3 form-focus focused">
                              <input
                                className="form-control"
                                type="text"
                                onChange={(e) =>
                                  setNIB(e.target.value)
                                }
                              />
                              <label className="focus-label">
                                {t("NIB")}{" "}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        

                         
                          <div className="submit-section">
                            <a
                              className="btn btn-primary submit-btn"
                              onClick={submitFormNovo}
                            >
                              {loading ? "Carregando" : t("Submit")}
                            </a>
                          </div>

                          <hr className="mt-4"></hr>
                        </div>
                      </form>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Personal Info Modal */}

      <ToastContainer />

      {loading ? (
        <>
          <Spinner></Spinner>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ContaBancariaModal;
